module.exports = __webpack_public_path__ + "img/beta-unsplash-02.c34fd95f.jpg";